import {
  Chip,
  Divider,
  Grid,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  Typography,
} from "@mui/material";
import { styled, useTheme } from "@mui/material/styles";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);
const ListItemWrapper = styled("div")(({ theme }) => ({
  cursor: "pointer",
  padding: 16,
  "&:hover": {
    background:
      theme.palette.mode === "dark"
        ? theme.palette.dark.main
        : theme.palette.primary.light,
  },
  "& .MuiListItem-root": {
    padding: 0,
  },
}));

// ==============================|| NOTIFICATION LIST ITEM ||============================== //

const NotificationList = ({ data }) => {
  const theme = useTheme();
  return (
    <List
      sx={{
        width: "100%",
        maxWidth: 430,
        py: 0,
        borderRadius: "10px",
        [theme.breakpoints.down("md")]: {
          maxWidth: 400,
        },
        "& .MuiListItemSecondaryAction-root": {
          top: 16,
        },
        "& .MuiDivider-root": {
          my: 0,
        },
        "& .list-container": {
          pl: 0,
        },
      }}
    >
      {data.map((item) => (
        <>
          <ListItemWrapper
            sx={{
              backgroundColor: theme.palette.background.default,
            }}
          >
            <ListItem alignItems="center">
              <ListItemText
                primary={
                  <Typography variant="subtitle1">{item.title}</Typography>
                }
              />
              <ListItemSecondaryAction>
                <Grid container justifyContent="flex-start">
                  <Grid item>
                    <Chip
                      size="small"
                      label={dayjs(item.created_at).fromNow()}
                    />
                  </Grid>
                </Grid>
              </ListItemSecondaryAction>
            </ListItem>
            <Grid container direction="column" className="list-container">
              <Grid item xs={12} sx={{ pb: 2 }}>
                <Typography variant="subtitle2">{item.message}</Typography>
              </Grid>
            </Grid>
          </ListItemWrapper>
          <Divider />
        </>
      ))}
    </List>
  );
};

export default NotificationList;
